module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_19.4e84b5db.png";